<template>
  <v-dialog width="400px" title="Create User" :visible.sync="dialogVisible" :scrollbar="false" :z-index="2000"
    @opened="onOpened" @closed="onClosed">
    <el-form ref="form" :model="form" :rules="formRules" label-position="top">
      <el-form-item prop="roleID" label="Role">
        <el-select v-model="form.roleID" placeholder="Please select role" @change="onRoleChange">
          <el-option v-for="(item, i) in roleList" :key="i" :value="item.RoleID" :label="item.RoleName" />
        </el-select>
      </el-form-item>
      <el-form-item prop="supervisorId" label="Manager" v-if="supervisorVisible">
        <el-select v-model="form.supervisorId" placeholder="Please select manager" :disabled="supervisorDisabled"
          filterable>
          <el-option v-for="(item, i) in supervisors" :key="i" :value="item.UserID" :label="item.Name" />
        </el-select>
      </el-form-item>
      <el-form-item prop="taId" :label="taLabel" v-if="taVisible">
        <el-select v-model="form.taId" :placeholder="taMessage" filterable>
          <el-option v-for="(item, i) in taList" :key="i" :value="item.TAID" :label="item.TAName" />
        </el-select>
      </el-form-item>
      <el-form-item prop="teamName" label="Team" v-if="teamNameVisible">
        <el-input v-model="form.teamName" placeholder="Please input team name" autocomplete="off" maxlength="50" />
      </el-form-item>
      <el-form-item prop="name" label="Name">
        <el-input v-model="form.name" placeholder="Please input name" maxlength="20" autocomplete="off" />
      </el-form-item>
      <el-form-item prop="loginName" label="LoginName">
        <el-input v-model="form.loginName" placeholder="Please input login Name" maxlength="25"
          @input="onLoginNameInput" autocomplete="off" />
      </el-form-item>
      <el-form-item prop="email" label="Email">
        <el-input v-model.trim="form.email" placeholder="Please input email" autocomplete="off" />
      </el-form-item>
      <el-form-item prop="phone" label="Phone">
        <el-input v-model="form.phone" placeholder="Please input phone" maxlength="20" @input="onPhoneInput"
          autocomplete="off" />
      </el-form-item>
      <el-form-item prop="taConfigId" label="TA" v-if="showTA">
        <el-select v-model="form.taConfigId" placeholder="Please select TA" filterable>
          <el-option v-for="item in taConfitList" :key="item.taConfigId" :label="item.taConfigName"
            :value="item.taConfigId" />
        </el-select>
      </el-form-item>
    </el-form>
    <div class="actions">
      <el-button type="primary" @click="onConfirm" :loading="loading">
        Submit{{ loading ? "ting" : "" }}
      </el-button>
      <el-button @click="onClosed">Cancel</el-button>
    </div>
  </v-dialog>
</template>

<script>
import { trimValidate } from "../../utils/validator";
import { LeaderLabelValues } from "@/utils/role-constant";

export default {
  name: "NewUserDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
      showTA: false,
    },
  },
  data() {
    const validateEmail = (rule, value, callback) => {
      const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (emailReg.test(value)) {
        callback();
      } else {
        callback(new Error("Email format error, please re-enter"));
      }
    };
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/;
      console.log('value:', value, phoneReg.test(value) , this.form.phone == "")
      if (phoneReg.test(value) || this.form.phone == "" || this.form.phone == null) {
        callback();
      } else {
        console.log('invalid phone')
        callback(new Error("Phone format error, please re-enter"));
      }
      
      // if (!Number.isInteger(+value)) {
      //   callback(new Error("Phone format error, please re-enter"));
      // } else {
      //   if (phoneReg.test(value) || this.form.phone == "") {
      //     callback();
      //   } else {
      //     callback(new Error("Phone format error, please re-enter"));
      //   }
      // }
    };
    return {
      dialogVisible: this.visible,
      roleList: [],
      supervisors: [
        {
          UserID: "",
          Name: "NA",
        },
      ],
      taList: [
        {
          TAID: "",
          TAName: "NA",
        },
      ],
      teamNameVisible: false,
      supervisorVisible: false,
      supervisorDisabled: false,
      taVisible: false,
      form: {
        name: "",
        loginName: "",
        email: "",
        roleID: "",
        supervisorId: "",
        phone: "",
        teamName: "",
        taId: "",
        taConfigId: null,
      },
      formRules: {
        name: [
          {
            required: true,
            validator: trimValidate("Please fill in the name"),
            trigger: "blur",
          },
        ],
        loginName: [
          {
            required: true,
            validator: trimValidate("Please fill in the login name"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: "blur",
          },
        ],
        supervisorId: [
          {
            required: true,
            message: "Please select the manager",
            trigger: "change",
          },
        ],
        phone: [{ validator: validatePhone, trigger: "change" }],
        teamName: [
          {
            required: false,
            validator: trimValidate("Please fill in the team name"),
            trigger: "blur",
          },
        ],
        taId: {
          required: false,
          message: "",
          trigger: "change",
        },
        taConfigId: [
          {
            required: false,
            message: "Please select TA",
            trigger: "change",
          },
        ],
      },
      loading: false,
      roleId: null,
      taConfitList: [],
      showTA: false
    };
  },
  computed: {
    taLabel() {
      return this.taVisible ? LeaderLabelValues[this.roleId].label : "";
    },
    taMessage() {
      return `Please select ${this.taLabel ? this.taLabel.toLowerCase() : ""}`;
    },
    tips() {
      return "This Team has a Manager, please confirm to replace the Manager.";
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onOpened() {
      this.getRoleList();
      this.getSupervisors();
      this.getTA();
      this.getTAList()
    },
    getTAList() {
      this.axios
        .get(`/user/taConfig`)
        .then(({ code, msg, data }) => {
          if (code === 200) {
            this.taConfitList = data
          } else {
            this.$message.error(msg);
          }
        });
    },
    onClosed() {
      this.roleId = null;
      this.taVisible = false; // MSL Leader
      this.formRules.taId.required = false;
      this.supervisorVisible = true; // Manager
      this.supervisorDisabled = false;
      this.formRules.supervisorId[0].required = true;
      this.teamNameVisible = false; // Team
      this.formRules.teamName[0].required = false;
      this.formRules.taConfigId[0].required = false;
      this.$refs.form.resetFields();
      this.$emit("update:visible", false);
    },
    onLoginNameInput(value) {
      this.form.loginName = value.toUpperCase();
    },
    onPhoneInput(value) {
      this.form.phone = value.replace(/\D/g, "");
    },
    onRoleChange(RoleID) {
      if (RoleID) {
        this.showTA = false
        this.formRules.taConfigId[0].required = false
        switch (RoleID) {
          case "75bed9cc-3fc7-4e81-bdfc-962f9d394946": // Supervisor
          case "94a2ff8d-a5f0-405a-abbb-2aee8be126d5": // CRP
          case "a2b2b73d-67ed-4f72-9428-8c791e8432f7": // SciCom
          case "751a30aa-4fea-4388-98d3-778003cb8e71": // CVEO
          case "84e3a762-be15-4c2c-8cfb-5c6aff988ac5": // CT
            this.roleId = RoleID;
            this.taVisible = true; // MSL Leader
            this.formRules.taId.required = true;
            this.formRules.taId.message = this.taMessage;
            this.form.taId = "";
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = false; // Manager
            this.formRules.supervisorId[0].required = false;
            this.form.supervisorId = "";
            this.$refs.form.clearValidate("supervisorId");
            this.formRules.teamName[0].required = true;
            this.$refs.form.clearValidate("teamName");
            this.teamNameVisible = RoleID === "75bed9cc-3fc7-4e81-bdfc-962f9d394946"; // Team
            if (this.teamNameVisible) {
              this.getTA();
              this.form.taConfigId = "";
              this.$refs.form.clearValidate("taConfigId");
              this.showTA = true;
              this.formRules.taConfigId[0].required = true;
            } else {
              this.getTA(`/user/taList/${LeaderLabelValues[RoleID].value}`);
            }
            break;
          case "0cb6ab37-2ab0-4123-80bd-c3e1f12adc32": // CRP Leader
          case "dd9472ff-e3a6-42da-b8bb-7796e026d82a": // SciCom Leader
          case "ece81c6e-aae5-45c2-8bdb-bf86e3c40e1f": // CVEO Leader
          case "1bb1860e-5dea-4568-bd42-e64bee93081b": // CT Leader
            this.taVisible = false; // Show Leader
            this.form.taId = "";
            this.formRules.taId.required = true;
            this.formRules.taId.message = this.taMessage;
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = false; // Manager
            this.formRules.supervisorId[0].required = false;
            this.form.supervisorId = "";
            this.$refs.form.clearValidate("supervisorId");
            this.teamNameVisible = true; // Team
            this.formRules.teamName[0].required = true;
            this.$refs.form.clearValidate("teamName");
            break;
          
          // case "522d6b01-4ad8-4222-865d-20dc67460898"://call center
          case "3ddd8bc6-c5ac-432d-ab0b-05d0e59d5d6e":// MSL Leader
            this.taVisible = false; // MSL Leader
            this.formRules.taId.required = false;
            this.form.taId = "";
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = false; // Manager
            this.formRules.supervisorId[0].required = false;
            this.form.supervisorId = "";
            this.$refs.form.clearValidate("supervisorId");
            this.teamNameVisible = false; // Team
            this.formRules.teamName[0].required = false;
            this.form.teamName = "";
            this.$refs.form.clearValidate("teamName");
            break;
          // Admin
          case "d271d4c8-cc66-4327-8911-47ba35dc57df":
            this.taVisible = false; // MSL Leader
            this.formRules.taId.required = false;
            this.form.taId = "";
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = true; // Manager
            this.supervisorDisabled = true;
            this.formRules.supervisorId[0].required = false;
            this.form.supervisorId = "";
            this.$refs.form.clearValidate("supervisorId");
            this.teamNameVisible = false; // Team
            this.formRules.teamName[0].required = false;
            this.form.teamName = "";
            this.$refs.form.clearValidate("teamName");
            break;
          // MSL
          case "d3eb0bb1-1752-41aa-8e62-11015ff6b2a2":
          case "abb4cd4c-4a81-4591-9f29-c25f6691a8a9": //vMSL
          case "522d6b01-4ad8-4222-865d-20dc67460898": //call center
            this.taVisible = false; // MSL Leader
            this.formRules.taId.required = false;
            this.form.taId = "";
            this.$refs.form.clearValidate("taId");
            this.supervisorVisible = true; // Manager
            this.supervisorDisabled = false;
            this.formRules.supervisorId[0].required = true;
            this.teamNameVisible = false; // Team
            this.formRules.teamName[0].required = false;
            this.form.teamName = "";
            this.$refs.form.clearValidate("teamName");
            this.form.taConfigId = "";
            this.$refs.form.clearValidate("taConfigId");
            this.getTA();
            this.showTA = true;
            this.formRules.taConfigId[0].required = RoleID !== "522d6b01-4ad8-4222-865d-20dc67460898";
            break;
        }
      }
    },
    getRoleList() {
      this.axios.get("/user/roleList").then(({ code, data, msg }) => {
        if (code === 200) {
          this.roleList = data;
          if (data && data.length > 0) {
            // default ML
            this.form.roleID = "d3eb0bb1-1752-41aa-8e62-11015ff6b2a2";
            this.onRoleChange(this.form.roleID);
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    getTA(url = "/user/taList/msl") {
      this.axios.get(url).then(({ code, data, msg }) => {
        if (code === 200) {
          this.taList = [
            {
              TAID: "",
              TAName: "NA",
            },
          ].concat(data);
        } else {
          this.$message.error(msg);
        }
      });
    },
    getSupervisors() {
      this.axios.get("/user/svList").then(({ code, data, msg }) => {
        if (code === 200) {
          this.supervisors = [
            {
              UserID: "",
              Name: "NA",
            },
          ].concat(data);
        } else {
          this.$message.error(msg);
        }
      });
    },
    checkTeamExist() {
      this.loading = true;
      this.axios.get("/user/checkTeamExist", {
        params: {
          roleId: this.form.roleID,
          teamName: this.form.teamName.trim()
        }
      }).then(({ code, data }) => {
        if (200 === code) {
          if (data) {
            this.$confirm(this.tips, {
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
              type: "warning"
            }).then(() => {
              this.submitRequest();
            }).catch(() => {
              this.loading = false;
            });
          } else {
            this.submitRequest();
          }
        } else {
          this.$message.error("Checking team exist failure.");
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    submitRequest() {
      this.loading = true;
      this.axios
        .post("/user/create", {
          name: this.form.name.trim(),
          loginName: this.form.loginName.trim(),
          email: this.form.email.trim(),
          roleID: this.form.roleID,
          supervisorId: this.form.supervisorId,
          phone: this.form.phone.trim(),
          teamName: this.form.teamName.trim(),
          taId: this.form.taId,
          taConfigId: this.form.taConfigId||null,
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$emit("success");
            this.$message.success("Create user successfully");
            this.onClosed();
          } else {
            this.$message.error(msg);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          "Please make sure if it is ready to submit?",
          "Attention",
          {
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
          }
        ).then(() => {
          if (this.teamNameVisible) {
            this.checkTeamExist();
          } else {
            this.submitRequest();
          }
        }).catch(() => {
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  .el-form-item {
    margin-bottom: 10px;
  }

  ::v-deep {
    .el-form-item__label {
      padding: 0 !important;
    }
  }

  .el-input,
  .el-select {
    width: 100%;
  }
}

.actions {
  margin-top: 20px;
  text-align: center;
}

::v-deep {
  .el-dialog__header {
    padding-bottom: 0;
  }

  .el-dialog__body {
    padding: 20px 40px 20px;
  }

  .el-dialog__footer {
    padding: 0;
  }
}
</style>
